import {
  renderActions,
  renderLastModifiedBy,
  renderLastModifiedDate,
  renderFeatureNameAndDescription,
  renderRolloutStatus,
  renderArchiveAction,
} from "./experimentTableRenderers";
import { ExperimentType, PipelineStatusMap } from "../Types";
import { addSortPropsToColumn, ColumnSortState } from "../Shared/shared.utils";
import { IColumn } from "@fluentui/react";
import { IMultiColumnHeaderColumn } from "./MultiColumnHeader";
import {
  MPAC_TYPE,
  PROD_TYPE,
  RC_TYPE,
} from "../Experiment/RolloutDetails/RolloutDetailsTable/RolloutDetailsEv2Panel/ev2TreatmentStages.consts";

export function getExperimentsTableColumns({
  runPipelineStatuses,
  loadingPipelineStatuses,
  handleClone,
  handleArchive,
  sortState,
  onColumnClick,
  hasAdoAccess,
}: {
  runPipelineStatuses: PipelineStatusMap | undefined;
  loadingPipelineStatuses: boolean;
  handleClone: (item: ExperimentType) => void;
  handleArchive: (item: ExperimentType) => void;
  hasAdoAccess: boolean | undefined;

  sortState: ColumnSortState;
  onColumnClick?: (ev: React.MouseEvent<HTMLElement>, column: IColumn) => void;
}): IMultiColumnHeaderColumn[] {
  const baseColumns: IMultiColumnHeaderColumn[] = [
    {
      key: "featureName",
      name: "Feature Name",
      fieldName: "featureName",
      multiColumnHeader: "Experiment Details",
      minWidth: 300,
      maxWidth: 1000,
      isResizable: true,
      onRender: renderFeatureNameAndDescription,
    },
    {
      key: "rolloutStatusRC",
      name: "RC",
      fieldName: "rolloutStatusRC",
      multiColumnHeader: "Latest Rollout Status",
      minWidth: 200,
      maxWidth: 400,
      isResizable: true,
      onRender: (item) =>
        renderRolloutStatus({
          item,
          environment: RC_TYPE,
          runPipelineStatuses: runPipelineStatuses || {},
          loadingPipelineStatuses,
        }),
    },
    {
      key: "rolloutStatusMPAC",
      name: "MPAC",
      fieldName: "rolloutStatusMPAC",
      multiColumnHeader: "Latest Rollout Status",
      minWidth: 200,
      maxWidth: 400,
      isResizable: true,
      onRender: (item) =>
        renderRolloutStatus({
          item,
          environment: MPAC_TYPE,
          runPipelineStatuses: runPipelineStatuses || {},
          loadingPipelineStatuses,
        }),
    },
    {
      key: "rolloutStatusPROD",
      name: "PROD",
      fieldName: "rolloutStatusPROD",
      multiColumnHeader: "Latest Rollout Status",
      minWidth: 200,
      maxWidth: 400,
      isResizable: true,
      onRender: (item) =>
        renderRolloutStatus({
          item,
          environment: PROD_TYPE,
          runPipelineStatuses: runPipelineStatuses || {},
          loadingPipelineStatuses,
        }),
    },
    {
      key: "lastModifiedBy",
      name: "Last Modified By",
      fieldName: "lastModifiedBy",
      multiColumnHeader: "Modified",
      minWidth: 170,
      maxWidth: 220,
      isResizable: true,
      onRender: renderLastModifiedBy,
    },
    {
      key: "lastModifiedDate",
      name: "Last Modified",
      fieldName: "lastModifiedDate",
      multiColumnHeader: "Modified",
      minWidth: 150,
      maxWidth: 200,
      isResizable: true,
      onRender: renderLastModifiedDate,
    },
    {
      key: "clone",
      name: "Clone",
      fieldName: "clone",
      multiColumnHeader: "Actions",
      minWidth: 60,
      maxWidth: 60,
      isResizable: false,
      isSorted: false,
      onRender: (item) => renderActions(item, handleClone, hasAdoAccess),
    },
    {
      key: "archive",
      name: "Archive",
      fieldName: "archive",
      multiColumnHeader: "Actions",
      minWidth: 60,
      maxWidth: 60,
      isResizable: false,
      isSorted: false,
      onRender: (item) =>
        renderArchiveAction(item, handleArchive, hasAdoAccess),
    },
  ];

  // Add sorting props only to sortable columns
  const sortableColumnKeys = [
    "featureName",
    "lastModifiedBy",
    "lastModifiedDate",
  ];

  return baseColumns.map((column) =>
    sortableColumnKeys.includes(column.key)
      ? addSortPropsToColumn(column, sortState, onColumnClick)
      : column,
  );
}
